export default "/react/tgAdsIcon-64140917.svg";